import { render, staticRenderFns } from "./Echarts5.vue?vue&type=template&id=198eb071&scoped=true&"
import script from "./Echarts5.vue?vue&type=script&lang=js&"
export * from "./Echarts5.vue?vue&type=script&lang=js&"
import style0 from "./Echarts5.vue?vue&type=style&index=0&id=198eb071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198eb071",
  null
  
)

export default component.exports